export const PLAY_CHAR_ID = "play_char";
